import { arrayOf, func, shape } from "prop-types"
import { forwardRef, useState, useEffect } from "react"

const KeyListener = forwardRef(function MyKeyListener({ register, render = () => null }, ref) {
  const clicked = useKeyListener({ elRef: ref, register })

  return render({ clicked })
})

export const useKeyListener = ({ elref, register, except = [] }) => {
  const [clicked, setClicked] = useState(null)

  useEffect(() => {
    addEventListeners(elref?.current)
    if (except.length > 0) {
      addExceptionListeners(
        except.map(e => {
          return e.current
        })
      )
    }
    return () => {
      if (elref) {
        removeEventListeners(elref?.current)
      }
      if (except.length > 0) {
        removeExceptionListeners(
          except.map(e => {
            return e.current
          })
        )
      }
    }
  }, [])

  const addEventListeners = el => {
    let root = window
    if (el) {
      root = el
    }
    root.addEventListener("click", handleClick, false)
    root.addEventListener("keyup", handleKeyUp, false)
    root.addEventListener("keydown", handleKeyDown, false)
  }

  const removeEventListeners = el => {
    let root = window
    if (el) {
      root = el
    }
    root.removeEventListener("click", handleClick, false)
    root.removeEventListener("keyup", handleKeyUp, false)
    root.removeEventListener("keydown", handleKeyDown, false)
  }

  const addExceptionListeners = els => {
    els.map(el => {
      if (el) {
        el.addEventListener("click", handleException, false)
        el.addEventListener("keydown", handleException, false)
      }
    })
  }

  const removeExceptionListeners = els => {
    els.map(el => {
      if (el) {
        el.removeEventListener("click", handleException, false)
        el.removeEventListener("keydown", handleException, false)
      }
    })
  }

  const handleKeyDown = e => {
    const key = registerKey(e)
    if (!register || !(key in register)) return
    const { [key]: handler } = register

    if (handler) {
      e.preventDefault()
      handler()
    }

    setClicked(key)
  }

  const handleException = e => {
    e.stopPropagation()
  }

  const handleKeyUp = () => {
    setClicked(null)
  }

  const handleClick = e => {
    const key = `${getModifier(e)}Click`
    if (!register || !(key in register)) return
    const { [key]: handler } = register

    if (handler) {
      e.preventDefault()
      e.stopPropagation()
      handler()
    }

    setClicked(key)
  }

  const registerKey = e => {
    const { key } = e
    const modifier = getModifier(e)

    return modifier == key ? key : `${modifier}${key}`
  }

  const getModifier = e => {
    let modifier = ""
    if (e.metaKey) {
      modifier = "Command"
    }
    if (e.shiftKey) {
      modifier = "Shift"
    }
    if (e.altKey) {
      modifier = "Alt"
    }
    if (e.ctrlKey) {
      modifier = "Control"
    }
    return modifier
  }

  return clicked
}

KeyListener.propTypes = {
  register: shape({}),
  elref: func,
  except: arrayOf(func),
  render: func
}

export default KeyListener
